// extracted by mini-css-extract-plugin
module.exports = {"signup-background":"_23Ffsyw9QVtpzmdZpw_kGE","footer":"e-i0glrYTCFtV0KkuiNNg","welcome-to":"_1eQB9ggerrKYhi044F7emY","small":"AKUL6MnvEyhKPsYv-vdm1"};